const isIOSUser = (userAgent: string) =>
  ['ios', 'iphone', 'ipad'].some((text) => userAgent.includes(text));

export const isMacOSUser = () => {
  const userAgent = window.navigator.userAgent;
  if (isIOSUser(userAgent)) return false;
  return userAgent.toLowerCase().includes('mac');
};

/**
 * Returns true only for iPhone. Excludes iPad (including iPadOS 13+, which
 * reports a desktop-Safari "Macintosh" user agent) and iPod, since those have
 * no Apple Wallet app to add passes to.
 */
export const isIPhoneDevice = (): boolean =>
  window.navigator.userAgent.toLowerCase().includes('iphone');

/**
 * Returns true for Android devices, including the Android in-app WebView (its
 * user agent keeps the `Android` token). Used to gate the Android-only PDF
 * blob workaround so every other platform keeps the standard flow.
 */
export const isAndroidDevice = (): boolean =>
  window.navigator.userAgent.toLowerCase().includes('android');

/**
 * Major Android version from the user agent — 14 for `Android 14; Pixel 8`.
 * Returns undefined when the user agent is not Android or carries no version,
 * leaving it to the caller to decide what an unknown version means.
 */
export const getAndroidMajorVersion = (): number | undefined => {
  const match = /android\s+(\d+)/.exec(
    window.navigator.userAgent.toLowerCase()
  );

  return match ? Number(match[1]) : undefined;
};
